<template>
  <div>
    <FilterMenu :is-open="isFilterMenuOpen" @close="isFilterMenuOpen = false" />
    <slot name="open-button" :open-filter-menu="() => { isFilterMenuOpen = true }">
      <BaseButton look="outline" @click="isFilterMenuOpen = true">
        <AdjustmentsHorizontalIcon class="size-6" aria-hidden="true" />Suodata
      </BaseButton>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { AdjustmentsHorizontalIcon } from '@heroicons/vue/24/outline'
import FilterMenu from '~/components/category/product-filters/FilterMenu.vue'

const isFilterMenuOpen = ref(false)
</script>
